import { render, staticRenderFns } from "./editRecommend.vue?vue&type=template&id=31e4cc1d&scoped=true"
import script from "./editRecommend.vue?vue&type=script&lang=js"
export * from "./editRecommend.vue?vue&type=script&lang=js"
import style0 from "./editRecommend.vue?vue&type=style&index=0&id=31e4cc1d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e4cc1d",
  null
  
)

export default component.exports